import axios from "axios";

export const PREMIUM_ENTITLEMENT_KEYS = Object.freeze({
  AI_WORKSPACE: "premium.ai_workspace",
  DATA_INTEGRATIONS: "premium.data_integrations",
  EMAIL_MARKETING: "premium.email_marketing",
  WORKFLOWS: "premium.workflows",
});

export const PREMIUM_ROUTE_FEATURES = Object.freeze({
  AiWorkspace: PREMIUM_ENTITLEMENT_KEYS.AI_WORKSPACE,
  NcrmDataIntegrations: PREMIUM_ENTITLEMENT_KEYS.DATA_INTEGRATIONS,
  NcrmImportDetails: PREMIUM_ENTITLEMENT_KEYS.DATA_INTEGRATIONS,
  NcrmEmailMarketing: PREMIUM_ENTITLEMENT_KEYS.EMAIL_MARKETING,
  NcrmWorkflowsHome: PREMIUM_ENTITLEMENT_KEYS.WORKFLOWS,
  NcrmWorkflowDetails: PREMIUM_ENTITLEMENT_KEYS.WORKFLOWS,
});

export const PREMIUM_FEATURE_SLUGS = Object.freeze({
  [PREMIUM_ENTITLEMENT_KEYS.AI_WORKSPACE]: "aiWorkspace",
  [PREMIUM_ENTITLEMENT_KEYS.DATA_INTEGRATIONS]: "dataIntegrations",
  [PREMIUM_ENTITLEMENT_KEYS.EMAIL_MARKETING]: "emailMarketing",
  [PREMIUM_ENTITLEMENT_KEYS.WORKFLOWS]: "workflows",
});

export const resolvePremiumFeatureForRoute = (routeName) =>
  PREMIUM_ROUTE_FEATURES[String(routeName || "")] || null;

export const resolvePremiumContactUrl = (locale) => {
  const normalized = ["ro", "en", "ru"].includes(String(locale || "").toLowerCase())
    ? String(locale).toLowerCase()
    : "ro";
  return `https://miridar.com/${normalized}/contact/`;
};

export const fetchPlatformAccess = () => axios.get("/platform-access");

export const resolveFeatureAccess = (snapshot, featureKey) =>
  snapshot?.features?.[featureKey] || {
    feature_key: featureKey,
    allowed: false,
    reason: "entitlement_required",
    read_only: false,
  };
